import { Route } from "react-router-dom";
import { lazy } from "react";

// Lazy load auth routes for code splitting
const Login = lazy(() => import("@/pages/Login"));
const ResetPassword = lazy(() => import("@/pages/ResetPassword"));
const AccountSetup = lazy(() => import("@/pages/AccountSetup"));

export const authRoutes = (
  <>
    <Route path="/login" element={<Login />} />
    <Route path="/reset-password" element={<ResetPassword />} />
    <Route path="/setup-account" element={<AccountSetup />} />
  </>
);
